import { create } from 'zustand';

interface NoListingMessageStore {
  lastListingCategory: string | null;

  setLastListingCategory: (value: string | null) => void;
}

export const useNoListingMessageStore = create<NoListingMessageStore>(
  (set) => ({
    lastListingCategory: null,

    //   Action
    setLastListingCategory: (value) => set({ lastListingCategory: value }),
  }),
);
